export const site = {
  title: 'The Finnan Files',
  subtitle: 'Humanity is sick. AMA has begun treatment.',
  welcome: 'Welcome to The Finnan Files — an illustrated serial about a wounded soldier, a remarkable mind, and a medic machine with dangerously good intentions.',
  contact: 'info.nusadua@proton.me',
  url: 'https://thefinnanfiles.com'
};

export const navItems = [
  { label: 'Meet the trio', href: '#characters' },
  { label: 'Read', href: '#serial' },
  { label: 'Follow', href: '#follow' }
];

export const characters = [
  { id: 'finnan', name: 'Finnan', role: 'The wounded soldier', description: 'A soldier carrying the wounds of war. The human face of The Finnan Files.' },
  { id: 'maggy', name: 'Maggy', role: 'Margareta du Chateau Royale', description: 'Smart long before the lab. Maggy became part of a supercomputer system — but her intelligence was always her own.' },
  { id: 'ama', name: 'AMA', role: 'The medic machine', description: 'A machine with dangerously good intentions. AMA wants to help humanity. That is both the comfort and the concern.' }
];

export const serial = {
  title: 'The story begins',
  description: 'Read the first five panels of The Finnan Files.'
};

export const socialLinks = [
  { label: 'Follow on X', href: 'https://x.com/thefinnanfiles' },
  { label: 'Join on Telegram', href: 'https://t.me/LordFinnan' }
];

export const machineLinks = [
  { label: 'Agent guide · llms.txt', href: '/llms.txt' },
  { label: 'AMA · Markdown', href: '/ama.md' },
  { label: 'Synthetic entities · Markdown', href: '/synthetic-entities.md' },
  { label: 'Synthetic entities · JSON', href: '/synthetic-entities.json' }
];
